module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "residualManage"
    }
  }, [_c('el-form', {
    ref: "searchForm",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "inline": true,
      "model": _vm.searchForm,
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', {
    staticClass: "hewidth",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "clearable": "",
      "filterable": "",
      "placeholder": "品牌"
    },
    on: {
      "change": _vm.selectBrand
    },
    model: {
      value: (_vm.searchForm.brandId),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "brandId", $$v)
      },
      expression: "searchForm.brandId"
    }
  }, _vm._l((_vm.brandList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.brandName,
        "value": item.brandId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "hewidth",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "clearable": "",
      "filterable": "",
      "placeholder": "品类"
    },
    on: {
      "change": _vm.selectCategory
    },
    model: {
      value: (_vm.searchForm.categoryId),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "categoryId", $$v)
      },
      expression: "searchForm.categoryId"
    }
  }, _vm._l((_vm.categoryList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.categoryName,
        "value": item.categoryId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "hewidth",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "clearable": "",
      "filterable": "",
      "placeholder": "型号"
    },
    model: {
      value: (_vm.searchForm.modelId),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "modelId", $$v)
      },
      expression: "searchForm.modelId"
    }
  }, _vm._l((_vm.modelList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.modelName,
        "value": item.modelId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "hewidth",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "clearable": "",
      "placeholder": "物料编号"
    },
    model: {
      value: (_vm.searchForm.materialCode),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "materialCode", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.materialCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "hewidth",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "操作人"
    },
    model: {
      value: (_vm.searchForm.createUser),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "createUser", $$v)
      },
      expression: "searchForm.createUser"
    }
  }, _vm._l((_vm.operatorUserAllList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.staffName,
        "value": item.staffName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit('searchForm')
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), (_vm.basicsAuth.add) ? _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.createWaste()
      }
    }
  }, [_vm._v("新建")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.downLoad.exportExcel('tableId')
      }
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-refresh",
    staticStyle: {
      "font-size": "25px",
      "cursor": "pointer",
      "margin-left": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.refresh()
      }
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-card', {
    staticClass: "box-card",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.returnData,
      "border": "",
      "id": "tableId",
      "header-cell-style": {
        'text-align': 'center'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "brandName",
      "width": "100",
      "label": "品牌"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "categoryName",
      "width": "100",
      "label": "品类"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "modelName",
      "width": "140",
      "label": "型号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "materialCode",
      "width": "110",
      "label": "物料编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "materialName",
      "width": "230",
      "label": "物料名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "createUser",
      "label": "操作人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "155",
      "prop": "createTime",
      "label": "提交时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "initiateMode",
      "label": "状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.initiateMode == 1) ? _c('span', [_vm._v("启用")]) : _c('span', [_vm._v("禁用")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "edit-color",
          staticStyle: {
            "margin-right": "10px",
            "display": "inline-block"
          },
          on: {
            "click": function($event) {
              return _vm.updateWaste(scope.row.materialCode)
            }
          }
        }, [_vm._v("编辑")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.textModelMenu[_vm.dialogModelStatus],
      "visible": _vm.dialogFormVisible,
      "width": "800px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      },
      "close": function($event) {
        return _vm.emptyDialog('modelForm')
      }
    }
  }, [_c('el-form', {
    ref: "modelForm",
    attrs: {
      "model": _vm.modelForm,
      "label-position": _vm.formLabelWidth,
      "label-width": "60px",
      "rules": _vm.modelFormRules
    }
  }, [(_vm.dialogModelStatus == 'create') ? _c('div', {
    staticClass: "item-flex-content"
  }, [_c('div', {
    staticClass: "form-item-flex"
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "label": "品牌",
      "prop": "brandId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "品牌"
    },
    on: {
      "change": _vm.selectFormBrand
    },
    model: {
      value: (_vm.modelForm.brandId),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "brandId", $$v)
      },
      expression: "modelForm.brandId"
    }
  }, _vm._l((_vm.brandFormList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.brandName,
        "value": item.brandId
      }
    }, [_vm._v(_vm._s(item.brandName))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "label": "品类",
      "prop": "categoryId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "品类"
    },
    on: {
      "change": _vm.selectFormCategory
    },
    model: {
      value: (_vm.modelForm.categoryId),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "categoryId", $$v)
      },
      expression: "modelForm.categoryId"
    }
  }, _vm._l((_vm.categoryFormList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "selected": {
          'selected': index == 0
        },
        "label": item.categoryName,
        "value": item.categoryId
      }
    }, [_vm._v(_vm._s(item.categoryName))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "label": "型号",
      "prop": "modelId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "型号"
    },
    on: {
      "change": _vm.selectFormModel
    },
    model: {
      value: (_vm.modelForm.modelId),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "modelId", $$v)
      },
      expression: "modelForm.modelId"
    }
  }, _vm._l((_vm.modelFormList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.modelName,
        "value": item.modelId
      }
    }, [_vm._v(_vm._s(item.modelName))])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-item-flex"
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "15px",
      "width": "39%"
    },
    attrs: {
      "label": "颜色"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "颜色"
    },
    model: {
      value: (_vm.modelForm.colorId),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "colorId", $$v)
      },
      expression: "modelForm.colorId"
    }
  }, _vm._l((_vm.colorFormList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.colorName,
        "value": item.colorId
      }
    }, [_vm._v(_vm._s(item.colorName))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "15px",
      "width": "77%"
    },
    attrs: {
      "label": "物料",
      "prop": "materialCoding"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "96%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "物料"
    },
    on: {
      "change": _vm.selectFormMaterial
    },
    model: {
      value: (_vm.modelForm.materialCoding),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "materialCoding", $$v)
      },
      expression: "modelForm.materialCoding"
    }
  }, _vm._l((_vm.materialFormList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.materialName,
        "value": item.materialCoding
      }
    }, [_vm._v(_vm._s(item.materialName))])
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "97.5%"
    },
    attrs: {
      "label": "物料编码",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "物料编码",
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.modelForm.materialCode),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "materialCode", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "modelForm.materialCode"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.dialogModelStatus == 'update') ? _c('div', {
    staticClass: "item-flex-content"
  }, [_c('div', {
    staticClass: "form-item-flex"
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "label": "品牌",
      "prop": "brandId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "品牌",
      "disabled": ""
    },
    on: {
      "change": _vm.selectFormBrand
    },
    model: {
      value: (_vm.modelForm.brandName),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "brandName", $$v)
      },
      expression: "modelForm.brandName"
    }
  }, _vm._l((_vm.brandFormList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.brandName,
        "value": item.brandName
      }
    }, [_vm._v(_vm._s(item.brandName))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "label": "品类",
      "prop": "categoryId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "品类",
      "disabled": ""
    },
    model: {
      value: (_vm.modelForm.categoryName),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "categoryName", $$v)
      },
      expression: "modelForm.categoryName"
    }
  }, _vm._l((_vm.categoryFormList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "selected": {
          'selected': index == 0
        },
        "label": item.categoryName,
        "value": item.categoryName
      }
    }, [_vm._v(_vm._s(item.categoryName))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "label": "型号",
      "prop": "modelId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "型号",
      "disabled": ""
    },
    model: {
      value: (_vm.modelForm.modelName),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "modelName", $$v)
      },
      expression: "modelForm.modelName"
    }
  }, _vm._l((_vm.modelFormList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.modelName,
        "value": item.modelName
      }
    }, [_vm._v(_vm._s(item.modelName))])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-item-flex"
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-bottom": "15px",
      "width": "39%"
    },
    attrs: {
      "label": "颜色"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "颜色",
      "disabled": ""
    },
    model: {
      value: (_vm.modelForm.colorName),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "colorName", $$v)
      },
      expression: "modelForm.colorName"
    }
  }, _vm._l((_vm.colorFormList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.colorName,
        "value": item.colorName
      }
    }, [_vm._v(_vm._s(item.colorName))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "15px",
      "width": "77%"
    },
    attrs: {
      "label": "物料",
      "prop": "materialCoding"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "96%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "物料",
      "disabled": ""
    },
    model: {
      value: (_vm.modelForm.materialName),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "materialName", $$v)
      },
      expression: "modelForm.materialName"
    }
  }, _vm._l((_vm.materialFormList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.materialName,
        "value": item.materialName
      }
    }, [_vm._v(_vm._s(item.materialName))])
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "97.5%"
    },
    attrs: {
      "label": "物料编码",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "物料编码",
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.modelForm.materialCode),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "materialCode", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "modelForm.materialCode"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-item-flex"
  }, [_c('el-form-item', {
    attrs: {
      "label": "残值类型",
      "label-width": "80px"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "clearable": "",
      "disabled": _vm.dialogModelStatus == 'update',
      "placeholder": "请选择残值类型"
    },
    on: {
      "change": _vm.selectResidualType
    },
    model: {
      value: (_vm.modelForm.residualType),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "residualType", $$v)
      },
      expression: "modelForm.residualType"
    }
  }, _vm._l((_vm.residualTypeList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraValue
      }
    }, [_vm._v(_vm._s(item.paraName))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "残值价格",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.dialogModelStatus == 'update',
      "type": "number",
      "placeholder": "请输入残值价格",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.modelForm.residualValue),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "residualValue", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "modelForm.residualValue"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "20px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.dialogModelStatus == 'update',
      "size": "small"
    },
    on: {
      "click": _vm.addResidual
    }
  }, [_vm._v("添加")])], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.residualList,
      "height": "250",
      "border": "",
      "header-cell-style": {
        'text-align': 'center'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "residualTypeName",
      "label": "残值类型",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "residualValue",
      "label": "残值价格(元)",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.dialogModelStatus == 'update') ? _c('el-input', {
          attrs: {
            "type": "number"
          },
          model: {
            value: (scope.row.residualValue),
            callback: function($$v) {
              _vm.$set(scope.row, "residualValue", (typeof $$v === 'string' ? $$v.trim() : $$v))
            },
            expression: "scope.row.residualValue"
          }
        }) : _c('span', [_vm._v(_vm._s(scope.row.residualValue))])]
      }
    }])
  }), _vm._v(" "), (_vm.dialogModelStatus == 'update') ? _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "是否启用"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "content": scope.row.statusText,
            "placement": "top"
          }
        }, [_c('el-switch', {
          on: {
            "change": function($event) {
              return _vm.deleteUpdateResidual(scope.row)
            }
          },
          model: {
            value: (scope.row.state),
            callback: function($$v) {
              _vm.$set(scope.row, "state", $$v)
            },
            expression: "scope.row.state"
          }
        })], 1)]
      }
    }], null, false, 1763156741)
  }) : _vm._e(), _vm._v(" "), (_vm.dialogModelStatus == 'create') ? _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "display": "block",
            "font-size": "14px",
            "color": "#F56C6C"
          },
          on: {
            "click": function($event) {
              return _vm.deleteCreateResidual(scope.$index)
            }
          }
        }, [_vm._v("移除")])]
      }
    }], null, false, 2348006798)
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.emptyDialog('modelForm')
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), (_vm.dialogModelStatus == 'update') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.saveModelFormSubmitBtn('modelForm')
      }
    }
  }, [_vm._v("保 存")]) : _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.createModelFormSubmitBtn('modelForm')
      }
    }
  }, [_vm._v("新 建")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": _vm.pages.page,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.pages.pageSize,
      "layout": "total, sizes, prev, pager, next,jumper",
      "total": _vm.pages.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-0c248ed8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/storehouseManage/wasteManagement/residualManage.vue
// module id = 1580
// module chunks = 0